import {
  FETCH_PVS_DETAILS_REQUEST,
  FETCH_PVS_DETAILS_SUCCESS,
  FETCH_PVS_DETAILS_FAILURE,
  FETCH_PVS_DETAILS_RESET,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchPvsDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PVS_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case FETCH_PVS_DETAILS_SUCCESS:
      console.log('FETCH_PVS_DETAILS_SUCCESS case invoked');
      
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      };

    case FETCH_PVS_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      };

    case FETCH_PVS_DETAILS_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchPvsDetailReducer;
